import { render, staticRenderFns } from "./FullWidthImage.vue?vue&type=template&id=69ee5e61&scoped=true&"
import script from "./FullWidthImage.vue?vue&type=script&lang=js&"
export * from "./FullWidthImage.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthImage.vue?vue&type=style&index=0&id=69ee5e61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ee5e61",
  null
  
)

export default component.exports